<template>
  <div class="container is-fluid">
    <div class="page-auth">
      <div class="columns">
        <div class="column is-one-third"></div>
        <div class="column content secondary-border">
          <div class="header">
            <img src="../assets/logo.png" class="logo" />
            <h5>Sign In</h5>
          </div>
          <div class="email-authentication secondary-border-bottom">
            <b-field label="Email">
              <b-input
                v-model="email"
                type="email"
                icon="email"
                maxlength="100"
              ></b-input>
            </b-field>
            <b-field label="Password">
              <b-input
                v-model="password"
                type="password"
                password-reveal
                icon="key-outline"
              ></b-input>
            </b-field>
            <div class="buttons">
              <b-button
                type="is-primary"
                expanded
                @click="signInWithEmailAndPassword"
                >Sign In</b-button
              >
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      loader: null
    };
  },
  mounted() {
    if (this.$auth.user) {
      this.succeed(this.$auth.user);
    }
  },
  methods: {
    succeed(user) {
      if (this.loader) {
        this.loader.close();
      }
      if (user.emailVerified) {
        setTimeout(() => {
          this.$router.push({ name: "home" });
        }, 200);
      } else {
        this.$auth.sendEmailVerification();
        this.$buefy.toast.open("Please verify email.");
      }
    },
    fail(error) {
      if (this.loader) {
        this.loader.close();
      }
      this.$buefy.toast.open(error.message);
    },
    signInWithEmailAndPassword() {
      this.loader = this.$buefy.loading.open();
      this.$auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(this.succeed)
        .catch(this.fail);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-auth {
  margin-top: 15vh;
  .content {
    padding: 16px;
    .header {
      text-align: center;

      img.logo {
        margin-top: 1rem;
        width: 150px;
      }
      h5 {
        margin-top: 8px;
      }
    }

    .email-authentication {
      padding-bottom: 1rem;
    }
    .social-authentication {
      .google-authentication {
        background: #ea4335;
        color: white;
      }
    }
  }
}
</style>
